// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010704/js/" + chunkId + "." + {"44":"8757c4e1","225":"c412c6eb","481":"ef727796","486":"d24013c2","770":"144d9ba6"}[chunkId] + ".0.3971617931047752.chunk.js";
};